// CallbackPage.tsx
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';
import { updateUserField } from '../../redux/slices/userSlice';
import { useLogout } from '../../hooks/useLogout';

const CallbackPage = () => {
  const { error: auth0Error } = useAuth0();
  const { logout } = useLogout();
  const dispatch = useDispatch();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    console.log('Starting authentication callback...');
    // If there's a referral code in sessionStorage, move into Redux
    try {
      const code = sessionStorage.getItem('referral_code');
      if (code) {
        dispatch(updateUserField({ key: 'referralCode', value: code }));
        // Optionally remove so it doesn't apply again:
        sessionStorage.removeItem('referral_code');
      }
    } catch (e) {
      console.warn('Could not read referral_code from sessionStorage', e);
    }

    if (auth0Error) {
      console.error('Authentication error:', auth0Error);
      setError('Authentication failed. Please try again.');
      setTimeout(() => {
        console.warn('Logging out due to authentication error');
        logout();
      }, 3000);
    }
  }, [auth0Error, logout, dispatch]);

  if (error) { console.error("Error ", error) }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <p className="text-xl font-semibold">Signing you in...</p>
        <p className="text-sm text-gray-500 mt-2">Please wait while we complete the authentication process</p>
      </div>
    </div>
  );
};

export default CallbackPage;
